import { render, staticRenderFns } from "./tbdjs.vue?vue&type=template&id=34e35419&scoped=true&"
import script from "./tbdjs.vue?vue&type=script&lang=js&"
export * from "./tbdjs.vue?vue&type=script&lang=js&"
import style0 from "./tbdjs.vue?vue&type=style&index=0&id=34e35419&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e35419",
  null
  
)

export default component.exports